import React from "react";
import ExNews from "../ExNews";
import Search from "../Search";
import Language from "../Language";
import Tracker from "../Tracker";
import Notification from "../Notification";

const TopNav = () => {
  return (
    <div className="">
      <div className="w-full">
        <ExNews />
      </div>
      {/* <div className="col-sm-4">
        <div className="row">
          <div className="col-sm-9">
            <Search />
          </div>

          <div className="col-sm-1">
            <Tracker />
          </div>

          <div className="col-sm-1">
            <Notification />
          </div>

          <div className="col-sm-1">
            <Language />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default TopNav;
